import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Products from "./Products";
import MOQ from "./MOQ.jpeg";
import { isMobile } from "react-device-detect";
import piologo from "../src/assets/image/pio-logo.png";

class PaperCarryBags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      onlineStoreBtn: false,
    };
  }
  componentDidMount() {
    const store = this.context;
    {
      isMobile
        ? this.setState({
          onlineStoreBtn: true,
        })
        : this.setState({
          onlineStoreBtn: false,
        });
    }
  }
  render() {
    return (
      <div>
        <div
          class="col-md-12 m-show online-ordering"
          id="onilne-store"
          style={{
            display: this.state.onlineStoreBtn == true ? "block" : "none",
          }}
        >
          <a
            class="mx-lg-3 btn shopnowbtn"
            // href="/ordercustomboxes"
            href="/onlinestore"
            style={{
              background: "#59c5d1",
              borderRadius: "3px",
              color: "white",
              width: "85%",
              boxShadow: "0px 0px 12px rgba(0,0,0,.5)",
              fontSize: "22px",
            }}
          >
            Online Store
          </a>
        </div>
        <Header></Header>
        <section class="page-banner">
          <div class="container-fluid px-md-4 px-3">
            <div class="row mt-4">
              <div class="col-md-12">
                <div class="top-breadcrumb">
                  <div className="w-100 text-center inner-pio-phn-logo justify-content-center d-md-none d-flex">
                    <img src={piologo} alt="pio-packaging" />
                  </div>
                  <ul>
                    <li class="breadcrumb-item">
                      <a href="http://piopackaging.com/">Home</a>
                    </li>
                    <li class="breadcrumb-item">
                      <a href="http://piopackaging.com/#products">Products</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Paper Carry Bags
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="section">
          <div class="quantity-icon">
            <img src={MOQ} alt="" />
          </div>
          <div class="container-fluid px-md-4 px-3">
            <div class="row">
              <div class="col-md-12">
                <div class="section-title text-center">
                  {/* <h2>Paper Carry Bags</h2> */}
                  <h1 className="mono-font-weight">Paper Carry Bags</h1>
                </div>
              </div>
              <div class="col-md-12">
                <div class="inner-page-cont">
                  <p>
                    We can offers you a wide range of paper carry bags in
                    various sizes, colours and quantities.
                  </p>
                  <p>The range contains</p>
                  <ul>
                    <li>
                      <i class="fa fa-dot-circle-o"></i> High-end carry bags
                      made from thick exclusive paper, fitted with fabric
                      handles
                    </li>
                    <li>
                      <i class="fa fa-dot-circle-o"></i> Multicolour printed
                      carry bags with a glossy or matt coating & lamination
                    </li>
                    <li>
                      <i class="fa fa-dot-circle-o"></i> Printed Kraft paper
                      carry bags with twisted cord or flat paper handles
                    </li>
                    <li>
                      <i class="fa fa-dot-circle-o"></i> Eco-friendly paper
                      carry bags using 100% recycled paper
                    </li>
                  </ul>
                  <p>
                    All the above bags can be manufactured with high quality
                    printing and special effects such as Drip-off UV, Spot UV,
                    Embossing & Foil Stamping in gold, silver and other colour
                    foils including rainbow holographic effect.
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="sub-section-title sub-section-title-black">
                  <h2>Sample Products</h2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-sm-6">
                <div class="product-item">
                  <div class="product-item-img">
                    <a
                      href="assets/img/paper-bag/paper-bag-02.png"
                      data-fancybox="images"
                    >
                      <img
                        class="img-fluid"
                        src="assets/img/paper-bag/thumb02.jpg"
                        alt="Paper Carry Bags"
                      />

                      <div class="product-view-btn">
                        <i class="fa fa-eye"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="product-item">
                  <div class="product-item-img">
                    <a
                      href="assets/img/paper-bag/paper-bag-03.png"
                      data-fancybox="images"
                    >
                      <img
                        class="img-fluid"
                        src="assets/img/paper-bag/thumb03.jpg"
                        alt="Paper Carry Bags"
                      />

                      <div class="product-view-btn">
                        <i class="fa fa-eye"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="product-item">
                  <div class="product-item-img">
                    <a
                      href="assets/img/paper-bag/paper-bag-04.jpg"
                      data-fancybox="images"
                    >
                      <img
                        class="img-fluid"
                        src="assets/img/paper-bag/thumb04.jpg"
                        alt="Paper Carry Bags"
                      />

                      <div class="product-view-btn">
                        <i class="fa fa-eye"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="product-item">
                  <div class="product-item-img">
                    <a
                      href="assets/img/paper-bag/paper-bag-05.jpg"
                      data-fancybox="images"
                    >
                      <img
                        class="img-fluid"
                        src="assets/img/paper-bag/thumb05.jpg"
                        alt="Paper Carry Bags"
                      />

                      <div class="product-view-btn">
                        <i class="fa fa-eye"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Products></Products>
        <Footer></Footer>
      </div>
    );
  }
}

export default PaperCarryBags;
